// import _ from 'lodash';
import { useTranslation } from '@tools/i18n';

export default function useLang() {
  const use = useTranslation('footer');
  return use;
}
